var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mt-5",attrs:{"data-method":"delete","outlined":"","dense":""},on:{"click":_vm.logout}},[_vm._v("\n  ログアウト\n")])}
var staticRenderFns = []

export { render, staticRenderFns }